import React, { useState } from "react";
import data from "../address.json";

function ContactUs() {
  const [expanded, setExpanded] = useState({});

  const toggleDistrict = (state, district) => {
    const key = `${state}-${district}`;
    setExpanded(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const mergedStates = Object.entries(data).map(([state, districtsRaw]) => {
    const districts = districtsRaw.reduce((acc, curr) => {
      const existing = acc.find(d => d.district === curr.district);
      if (existing) {
        existing.branches = existing.branches.concat(curr.branches);
      } else {
        acc.push({ ...curr });
      }
      return acc;
    }, []);
    return { state, districts };
  });

  // ✅ Return JSX
  return (
    <section className="branch-section" id="contact">
      <div className="text-center">
        <h2 className="branch-title">Our Branches</h2>
      </div>
      <div className="head-office-card">
        <h3><i className="fas fa-building"></i> Head Office</h3>
        <p>#11, Krishnappa Layout, Near Bus Stop, Bangarappa Nagar, Bangalore - 560085</p>
        <p><i className="fas fa-phone-alt"></i> 9480763399 / 9480764499 / 9480743399 / 9035143199</p>
        <p><i className="fas fa-envelope"></i> knslogistic1@gmail.com</p>
      </div>
      <div className="brochure-download">
        <a href="/KNS_brochure.PDF" download className="download-btn">
          <i className="fas fa-download"></i> Download Brochure
        </a>
      </div>
      {mergedStates.map(({ state, districts }) => (
        <div key={state} className="state-block">
          <h2>{state} Branches</h2>
          <div className="district-grid">
            {districts.map((districtData, idx) => {
              const key = `${state}-${districtData.district}`;
              if (districtData.district.toLowerCase() === "bangalore") return null;
              return (
                <React.Fragment key={key}>
                  <div className="district-card" onClick={() => toggleDistrict(state, districtData.district)}>
                    <div className="district-header">
                      <i className="fas fa-map-marker-alt m-b-0-5rem"></i>
                      <h4>{districtData.district}</h4>
                    </div>
                  </div>
              
                  {expanded[key] && (
                    <div className="branch-details-full">
                      {districtData.branches.map((branch, i) => (
                        <div key={i} className="branch-item">
                          <div className="d-flex flex-row addres-box">
                            <div className="address-left">
                              <p className="branch-address">
                                <i className="fa-solid fa-lg fa-building"></i> {branch.address}
                              </p>
                              <ul className="branch-contacts">
                                {branch.contacts.map((contact, j) => (
                                  <li key={j}>
                                    <i className="fas fa-phone"></i> <strong>{contact.name}:</strong> {contact.phone}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            {branch.delivery_point && (
                              <div className="delivery-point">
                                <h5>
                                  <i className="fa-solid fa-location-dot"></i> Delivery Points
                                </h5>
                                <div className="delivery-pills">
                                  {branch.delivery_point.split(",").map((point, idx) => (
                                    <span key={idx} className="pill">{point.trim()}</span>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </React.Fragment>
              );              
            })}
          </div>
        </div>
      ))}
      <div className="container mt-5">
                <div className="alert alert-warning border-1 border-dark-subtle small" role="alert">
                  <strong>Disclaimer / Note:</strong><br></br>
                  The information provided above is for reference purposes only. KNS Logistics shall not be held liable for any consequences resulting from incorrect, omitted, or outdated information presented on this website. We have made every effort to simplify the GST process for the convenience of our customers. However, customers are strongly advised to stay updated with the latest government regulations, as these are subject to change over time.
                </div>
              </div>
    </section>
  );
}

export default ContactUs;


/*function ContactUs(){
    const branches = [
        {
          city: "Bangalore",
          image: "bangalore.webp",
          phone: "+91 98765 43210"
        },
        {
          city: "Chennai",
          image: "chennai-marina-beach.webp",
          phone: "+91 91234 56789"
        },
        {
          city: "Erode",
          image: "erode.webp",
          phone: "+91 99887 77665"
        }
      ];
      
    return (
    <section id="contact" className="contact-section">
        <h2 className="contact-title">Our Branches</h2>
        <div className="branches-grid">
            {branches.map((branch, i) => (
            <div key={i} className="branch-card">
                <div className="branch-image-wrapper">
                    <img src={`/branches/${branch.image}`} alt={branch.city} />
                    <div className="contact-overlay">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-ms-12 branch-details">
                            <i className="fas fa-phone fa-sm"></i><p>{branch.phone}</p>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xs-12 branch-location">
                            <i className="fas fa-map-marker-alt"></i><h3 className="branch-city">{branch.city}</h3>
                        </div>
                    </div>
                </div>
            </div>
            ))}
        </div>
    </section>
    );

}

export default ContactUs;*/